import type { ImpressionType } from '@/ImpressionType'

export const impressionDataMenage: ImpressionType = {
  title: 'Récurrence',
  impressionContent: `
<p>
Ballet de bruits,<br/>
Qui bercent la nuit,<br/>
De ce taudis,<br/>
Qui me sert de lit.<br/>
<br/>
</p>


<p>
Homme moderne,<br/>
Que le ménage appel,<br/>
Nécessaires corvées,<br/>
Que mon corps épuisé,<br/>
S'obstine à terminer ?<br/>
Qui sait !<br/>
<br/>
</p>

<p>
C'est une danse,<br/>
Celle des couteaux, fourchettes et cuillère,<br/>
Dont on cherche les paires,<br/>
Comme les vêtements,<br/>
Qui pendent au vent.<br/>
<br/>
</p>

<p>
Humide,<br/> 
Alourdit,<br/>
Ils se détendent, léger,<br/>
Caressé,<br/>
Par le soleil de l'été.<br/>
Puis sec, s'enfile,<br/>
Froissé,<br/>
Pas repassé,<br/>
Négligé ? Oui, mais propret !<br/>
<br/>
</p>

<p>
C'est un cycle,<br/>
Éternel recommencement,<br/>
Herculéenne Tache,<br/>
Que de nettoyer chaque soir,<br/>
Les écuries d'Augias.<br/>
<br/>
</p>

<p>
Tandis que, secrète,<br/>
Nombre de discrètes,<br/>
Maintienne un foyer,<br/>
Parfait,<br/>
Sans vocaliser,<br/>
Les souffrances d'un mâle,<br/>
Empêché,<br/>
De ne rien glander.<br/>
<br/>
</p>

<p>
Modernité.<br/>
</p>
  `,
  illustrationCaption: 'Machine magique',
  illustrationCopyright: 'Source: stability.ai',
  illustrationPath: '/img/impressions/magic-cleaning-1.jpg',
  noteEntries: ["Inspiré par la mélodie... d'un lave vaisselle !"]
}
